import TeamModal from './TeamModal'

export default TeamModal
